"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.omit = void 0;
function omit(obj, keys) {
    const out = { ...obj };
    for (const key of keys)
        delete out[key];
    return out;
}
exports.omit = omit;
//# sourceMappingURL=omit.js.map